'use client';

import React from 'react';
import Link from 'next/link';
import MarketingNav from '@/components/MarketingNav';
import MarketingFooter from '@/components/MarketingFooter';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

interface LegalPageShellProps {
  children: React.ReactNode;
}

export default function LegalPageShell({ children }: LegalPageShellProps) {
  const { t } = useLanguage();
  const common = t?.legalPages?.common;

  return (
    <>
      <MarketingNav />
      <div className="min-h-screen bg-background pt-24 pb-8">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 mb-6">
          <Link
            href="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={14} />
            {common?.backToHome ?? 'Back to Home'}
          </Link>
        </div>
        {children}
      </div>
      <MarketingFooter />
    </>
  );
}
